import {
  Component,
  Input,
  Optional,
  OnInit,
} from '@angular/core';
import {FormArrayName, FormArray} from '@angular/forms';

// TODO Query for formArrayName, formGroup; rpFormArray input only supplements this

export class RpFormArrayLabelComponent implements OnInit {
   title: string;
   itemName: string;
   inputArray: FormArray;

  public array: FormArray;

  constructor( private formArray: FormArrayName) {}

  ngOnInit() {
    this.array = this.inputArray || this.formArray.control;
  }

  get buttonText() {
    return this.itemName ? `+${this.itemName}` : '+';
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'rp-form-array-label',
  styles: [`
  `],
  template: `
    <div *ngIf="title" class="rp-controls__label">{{title}}</div>

    <button [rpFormArrayAdd]="array" type="button">{{buttonText}}</button>
  `,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormArrayName, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input },],
'itemName': [{ type: Input },],
'inputArray': [{ type: Input, args: ['array', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
